export const LiveGames = [
  {
    gameID: "1",
    provider: "Popok",
    id: "75508",
    name: "Jacks or Better",
    img: "/images/livecasino/jack-or-better.webp",
    type: ["Live"],
  },
  {
    gameID: "2",
    provider: "Popok",
    id: "75301",
    name: "Roulette",
    img: "/images/livecasino/popok-roulette.webp",
    type: ["Live"],
  },
  {
    gameID: "3",
    provider: "Popok",
    id: "75507",
    name: "Baccarat",
    img: "/images/livecasino/popok-baccarat.webp",
    type: ["Live"],
  },
  {
    gameID: "4",
    provider: "Popok",
    id: "75303",
    name: "Diamond Fruit",
    img: "/images/livecasino/popok-diamond-fruit.webp",
    type: ["Live"],
  },
  {
    gameID: "5",
    provider: "Evolution",
    id: "25000",
    name: "Lightning Baccarat",
    img: "/images/livecasino/000002.webp",
    type: ["Baccarat"],
  },
  {
    gameID: "6",
    provider: "Evolution",
    id: "25000",
    name: "American Roulette",
    img: "/images/livecasino/000003.webp",
    type: ["Roulette"],
  },
  {
    gameID: "7",
    provider: "Evolution",
    id: "25000",
    name: "Hi Lo",
    img: "/images/livecasino/000004.webp",
    type: ["First Person"],
  },
  {
    gameID: "8",
    provider: "Evolution",
    id: "25000",
    name: "Baccarat First Person",
    img: "/images/livecasino/000005.webp",
    type: ["Baccarat", "First Person"],
  },
  {
    gameID: "9",
    provider: "Evolution",
    id: "25000",
    name: "Mega Ball",
    img: "/images/livecasino/000006.webp",
    type: ["First Person"],
  },
  {
    gameID: "10",
    provider: "Evolution",
    id: "25000",
    name: "Fan Tan",
    img: "/images/livecasino/000008.webp",
    type: ["Live"],
  },
  {
    gameID: "11",
    provider: "Evolution",
    id: "25000",
    name: "Craps",
    img: "/images/livecasino/000009.webp",
    type: ["First Person"],
  },
  {
    gameID: "12",
    provider: "Evolution",
    id: "25000",
    name: "Crazy Balls",
    img: "/images/livecasino/000010.webp",
    type: ["Live"],
  },
  {
    gameID: "13",
    provider: "Evolution",
    id: "25000",
    name: "Deal or No Deal",
    img: "/images/livecasino/000011.webp",
    type: ["Live"],
  },
  {
    gameID: "14",
    provider: "Evolution",
    id: "25000",
    name: "Double Ball",
    img: "/images/livecasino/000012.webp",
    type: ["Roulette"],
  },
  {
    gameID: "15",
    provider: "Evolution",
    id: "25000",
    name: "Video Poker",
    img: "/images/livecasino/000007.webp",
    type: ["Live"],
  },
  {
    gameID: "16",
    provider: "AE Casino",
    id: "46001",
    name: "Baccarat",
    img: "/images/livecasino/100001.webp",
    type: ["Baccarat"],
  },
  {
    gameID: "17",
    provider: "AE Casino",
    id: "46001",
    name: "Dice",
    img: "/images/livecasino/100002.webp",
    type: ["Live"],
  },
  {
    gameID: "18",
    provider: "AE Casino",
    id: "46001",
    name: "Dragon Tiger",
    img: "/images/livecasino/100003.webp",
    type: ["Live"],
  },
  {
    gameID: "19",
    provider: "AE Casino",
    id: "46001",
    name: "Roulette",
    img: "/images/livecasino/100004.webp",
    type: ["Roulette"],
  },
  {
    gameID: "20",
    provider: "AE Casino",
    id: "46001",
    name: "Sedie",
    img: "/images/livecasino/100005.webp",
    type: ["Live"],
  },
  {
    gameID: "21",
    provider: "SA Gaming",
    id: "36001",
    name: "Baccarat",
    img: "/images/livecasino/200001.webp",
    type: ["Baccarat"],
  },
  {
    gameID: "22",
    provider: "SA Gaming",
    id: "36001",
    name: "Blackjack",
    img: "/images/livecasino/200008.webp",
    type: ["Live"],
  },
  {
    gameID: "23",
    provider: "SA Gaming",
    id: "36001",
    name: "Dragon Tiger",
    img: "/images/livecasino/200009.webp",
    type: ["Live"],
  },
  {
    gameID: "24",
    provider: "SA Gaming",
    id: "36001",
    name: "Roulette",
    img: "/images/livecasino/200011.webp",
    type: ["Roulette"],
  },
  {
    gameID: "25",
    provider: "SA Gaming",
    id: "36001",
    name: "Sicbo",
    img: "/images/livecasino/200012.webp",
    type: ["Live"],
  },
  {
    gameID: "26",
    provider: "SA Gaming",
    id: "36001",
    name: "Thai HiLo",
    img: "/images/livecasino/200013.webp",
    type: ["Live"],
  },
  {
    gameID: "27",
    provider: "SA Gaming",
    id: "36001",
    name: "Xoc Dia",
    img: "/images/livecasino/200014.webp",
    type: ["Live"],
  },
  {
    gameID: "28",
    provider: "SA Gaming",
    id: "36001",
    name: "Speed Baccarat",
    img: "/images/livecasino/200015.webp",
    type: ["Baccarat"],
  },
  {
    gameID: "29",
    provider: "AFB",
    id: "74001",
    name: "Baccarat",
    img: "/images/livecasino/74001.webp",
    type: ["Baccarat"],
  },
  // {
  //   gameID: "30",
  //   provider: "Playtech",
  //   id: "96901",
  //   name: "Quantum Baccarat",
  //   img: "/images/livecasino/96901.webp",
  //   type: ["Baccarat"],
  // },
  // {
  //   gameID: "31",
  //   provider: "Playtech",
  //   id: "96901",
  //   name: "Roulette Live",
  //   img: "/images/livecasino/96902.webp",
  //   type: ["Roulette"],
  // },
  {
    gameID: "32",
    provider: "Pragmatic",
    id: "84100",
    name: "Speed Baccarat 1",
    img: "/images/livecasino/8410001.webp",
    type: ["Baccarat"],
  },
  {
    gameID: "35",
    provider: "Pragmatic",
    id: "84100",
    name: "Speed Auto Roulette",
    img: "/images/livecasino/8410004.webp",
    type: ["Roulette"],
  },
  {
    gameID: "36",
    provider: "Pragmatic",
    id: "84100",
    name: "Blackjack 5",
    img: "/images/livecasino/8410005.webp",
    type: ["Blackjack"],
  },
  {
    gameID: "33",
    provider: "Pragmatic",
    id: "84100",
    name: "Blackjack",
    img: "/images/livecasino/8410002.webp",
    type: ["Blackjack"],
  },
  {
    gameID: "34",
    provider: "Pragmatic",
    id: "84100",
    name: "Mega Roulette",
    img: "/images/livecasino/8410003.webp",
    type: ["Roulette"],
  },
]
